import type { HTMLAttributes } from 'react';
import type React from 'react';

import { Avatar, Button, Text } from '@change/ds-core-ui';

import { useDecisionMakerResponseByLine } from './hooks/useDecisionMakerResponseByLine';

export const DecisionMakerResponseByLine: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
	const {
		data: { author },
	} = useDecisionMakerResponseByLine();

	return (
		<div className="mt-6 mb-6 flex items-start gap-[12px] md:mt-[52px] md:mb-[52px]" {...props}>
			<Avatar size="large" src={author.photoUrl} alt="" />
			<div className="flex flex-1 flex-col items-start gap-1">
				{author.profileUrl ? (
					<Button
						variant="tertiary"
						as="a"
						href={author.profileUrl}
						className="p-0 text-ellipsis decoration-[0.5px]"
						size="large"
					>
						{author.displayName}
					</Button>
				) : (
					<Text variant="body" className="text-ellipsis decoration-[0.5px]" size="large" fontWeight="bold">
						{author.displayName}
					</Text>
				)}

				{author.title && (
					<Text variant="body" size="medium" className="text-typography-weak text-ellipsis">
						{author.title}
					</Text>
				)}
			</div>
		</div>
	);
};
